import { ReactElement } from 'react'
import { useIntl, defineMessages } from 'react-intl'

import { SelectTags } from 'components/v2/SelectTags'
import { GTPassengerTypeV2 } from 'gql/types.generated'
import { GET_PASSENGER_TYPES_AUTOCOMPLETE } from 'features/PassengerTypes/queries-legacy'
import { useQuery } from '@apollo/client'
import { ISelectPassengerTypesProps } from './types'

const messages = defineMessages({
  selectPassengerTypes: {
    id: 'selectPassengerTypes.placeholder',
    defaultMessage: 'Select passenger types'
  }
})

const SelectPassengerTypes = <TPassengerTypeValue extends Omit<TSFixMe, '__typename'>>({
  values,
  onChange,
  touched,
  errors,
  disabled,
  countryCode,
  showCountryCode,
  salesChannels
}: ISelectPassengerTypesProps<TPassengerTypeValue>): ReactElement => {
  const intl = useIntl()
  const { data } = useQuery<{ passengerTypesAutocomplete: TPassengerTypeValue[] }>(GET_PASSENGER_TYPES_AUTOCOMPLETE, {
    variables: {
      input: {
        countryCode: countryCode,
        salesChannelsIDs: salesChannels ? salesChannels.map(({ id }) => id) : []
      }
    }
  })
  const handleChange = (values: TPassengerTypeValue[]): void => onChange(values)

  const getOptions = (items: TPassengerTypeValue[]): TPassengerTypeValue[] => {
    return items.filter((item): boolean => {
      return !values?.find((value): boolean => value.id === item.id)
    })
  }
  const getLabel = (passenger: GTPassengerTypeV2): string => {
    if (showCountryCode) {
      return `${passenger.name} (${passenger.countryCode})`
    }
    return `${passenger.name}`
  }
  return (
    <SelectTags
      id="selectPassengerTypes"
      placeholder={intl.formatMessage(messages.selectPassengerTypes)}
      values={values || []}
      items={getOptions(data?.passengerTypesAutocomplete ?? [])}
      getTagLabel={getLabel}
      onChange={handleChange}
      touched={touched}
      errors={errors}
      disabled={disabled}
    />
  )
}

export default SelectPassengerTypes
